var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOpenCircle(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 10H15C15.552 10 16 10.448 16 11C16 11.552 15.552 12 15 12H12V15C12 15.552 11.552 16 11 16C10.448 16 10 15.552 10 15V12H7C6.448 12 6 11.552 6 11C6 10.448 6.448 10 7 10H10V7C10 6.448 10.448 6 11 6C11.552 6 12 6.448 12 7V10ZM11 22C4.925 22 0 17.075 0 11C0 4.925 4.925 0 11 0C17.075 0 22 4.925 22 11C22 17.075 17.075 22 11 22ZM11 20C15.971 20 20 15.971 20 11C20 6.029 15.971 2 11 2C6.029 2 2 6.029 2 11C2 15.971 6.029 20 11 20Z",
    fill: "#51585C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOpenCircle);
export default __webpack_public_path__ + "static/media/open-circle.fe74ff1e8e4278cb98c6f9daaa3281a0.svg";
export { ForwardRef as ReactComponent };